import { cloneDeep } from "lodash";
import merge from "lodash/merge";
import * as actionTypes from "../actions/actionTypes";

// Creates a reducer managing pagination, given the action types to handle,
// and a function telling how to extract the key from an action.
// Pagination section of the state tree keeps track of page count & fetching state.
export default function paginate({ types, mapActionToKey }) {
  if (!Array.isArray(types) || types.length !== 3) {
    throw new Error("Expected types to be an array of three elements.");
  }
  if (!types.every(t => typeof t === "string")) {
    throw new Error("Expected types to be strings.");
  }
  if (typeof mapActionToKey !== "function") {
    throw new Error("Expected mapActionToKey to be a function.");
  }

  const [requestType, successType, failureType] = types;

  function updatePagination(
    state = {
      isFetching: false,
      pageCount: 0,
    },
    action
  ) {
    switch (action.type) {
      case requestType:
        return merge({}, state, {
          isFetching: true,
        });
      case successType:
        return merge({}, state, {
          isFetching: false,
          pageCount: action.page,
        });
      case failureType:
        return merge({}, state, {
          isFetching: false,
        });
      default:
        return state;
    }
  }

  return function updatePaginationByKey(state = {}, action) {
    switch (action.type) {
      case requestType:
      case successType:
      case failureType: {
        const key = mapActionToKey(action);
        if (typeof key !== "string" && !(Array.isArray(key) || typeof key[0] !== "string")) {
          throw new Error(
            `Expected key to be a string or an array of strings (paginating ${action.type})`
          );
        }
        return merge(
          {},
          state,
          ...(Array.isArray(key) ? key : [key]).map(k => ({
            [k]: updatePagination(state[k], action),
          }))
        );
      }
      case actionTypes.RESET_SECTION: {
        const sectionId = action.sectionId + "-0";
        const newState = cloneDeep(state);
        if (newState[sectionId]) {
          delete newState[sectionId];
        }
        return newState;
      }
      default:
        return state;
    }
  };
}
